import React, {useState} from 'react';
import './stylesMarketplace.css';

/* A function that is used to filter the data that is displayed in the table. */
function DesktopSearchPanelElement1(props) {
	/* A destructuring assignment. */
	const {setFiltro, Filtro} = props;

	/* A destructuring assignment. */
	const [Text, setText] = useState({
		servicioName: '',
	});

	/* A destructuring assignment. */
	const {servicioName: servicioName} = Text;

	/**
	 * A function that is used to filter the data that is displayed in the table.
	 */
	const onInputChange = ({target}) => {
		const {name, value} = target;
		setText({
			[name]: value,
		});
		setFiltro({
			...Filtro,
			servicio: value,
		});
	};

	return (
		<>
			<div className='desktopSearchPanelElement1'>
				<div className='centradorSearchPanel infoPrimario'>
					<p>
						<b>¿Qué estas buscando?</b>
					</p>
				</div>
				<div className='centradorSearchPanel1 infoSecundario'>
					<input
						className='inputTipoServicio'
						type='text'
						placeholder='Servicio'
						name='username'
						value={servicioName}
						onChange={onInputChange}
					></input>
				</div>
			</div>
		</>
	);
}

export default DesktopSearchPanelElement1;
